import React, { useState , useEffect , useRef} from 'react';
import "../css/app.scss";
import axios from "axios";

const App = ({JSONdata}) => {
  const [dataPDF, setDataPDF] = useState(0); // Sample data
  const [error, setError] = useState(null);
  

    useEffect(() => {
      generatePdf();
    } ,[]);


  const generatePdf =  async () => {
   
      

      try {
          const params = {
            action: "get_HtmlPDFForm",
            nonce: react_ajax_object.ajax_react_nonce,
            
          };
      
          let response =  axios.get(react_ajax_object.ajax_react, {
            params: params,
            responseType: 'blob',
          }).then((res) => res.data);

          response.then((res) =>{
            // console.log(res);
            const pdfBlob = new Blob([res], { type: 'application/pdf' });
           
            const pdfUrl = URL.createObjectURL(pdfBlob);
            setDataPDF(pdfUrl);
            console.log(pdfUrl);
          });
          
          
          
        } catch (error) {
          setError(error);
        }
     
    
  };

  

  return (
    <div>
 {error ? (
        <p>Error fetching PDF: {error.message}</p>
      ) : (
        <>
          {dataPDF ? (
            
            <iframe
            src={dataPDF}
            title="Fetched PDF"
            width="827px"
            height="1169px" // Adjust height as needed
          />
           
          ) : (
            <p>Loading PDF...</p>
          )}
        </>
      )}
   
   
    </div>
  );
};

export default App;